import React, { Component } from 'react'
import T from 'i18n-react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import injectSagas from 'helpers/injectSagas'
import { withRouter } from 'react-router'
import { compose } from 'recompose'

import { Tab } from 'react-toolbox/lib/tabs'
import SpecificationData from './SpecificationData'
import RevisionDropdownContainer from './RevisionDropdownContainer'
import Tabs from './Tabs'
import FilterDropDown from './FilterDropdown'
import RevisionDropdown from './RevisionDropdown'
import {
  allRevisionsSelector,
  revisionDataSelector,
  groupedDataSelector
} from './selectors'
import {
  originalRevisionId,
  modifiedRevisionId,
  modifiedRevisionCreatedBy,
  modifiedRevisionIndex,
  modifiedRevisionCreatedAt,
  originalRevisionCreatedBy, 
  originalRevisionCreatedAt,
  originalRevisionIndex
} from 'containers/Project/Revision/selectors'
import {
  MODULES,
  FILTER_MODIFIED,
  MODULE_NAME,
  TABS
} from './constants'
import {
  selectFilter,
  updateModifiedRevision,
  updateOriginalRevision,
} from './actions'
import loadSagas from './sagas'  
import Divider from 'components/fulcrum/divider/Divider'

const mapStateToProps = (state) => {
  return {
    groupedData: groupedDataSelector(state),
    revisionData: revisionDataSelector(state),
    revisions: allRevisionsSelector(state),
    modified: modifiedRevisionId(state),
    reference: originalRevisionId(state),
    curFilter: state.uiState.specFilter.curFilter,
    modifiedRevisionCreatedBy: modifiedRevisionCreatedBy(state),
    modifiedRevisionCreatedAt: modifiedRevisionCreatedAt(state),
    modifiedRevisionIndex: modifiedRevisionIndex(state),
    originalRevisionCreatedBy: originalRevisionCreatedBy(state),
    originalRevisionCreatedAt: originalRevisionCreatedAt(state),
    originalRevisionIndex: originalRevisionIndex(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectFilter: (filter) => dispatch(selectFilter(filter)),
    onReferenceChange: (projectId, revisionId) => dispatch(updateOriginalRevision(projectId, revisionId)),
    onModifiedChange: (projectId, revisionId) => dispatch(updateModifiedRevision(projectId, revisionId))
  }
}

class Specifications extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tabIndex: 0,
    }
  }

  onReferenceChange = (value) => this.props.onReferenceChange(this.props.match.params.id, value)
  onModifiedChange = (value) => this.props.onModifiedChange(this.props.match.params.id, value)
  onTabChange = (index) => this.setState({tabIndex: index})

  render() {
    const {
      curFilter,
      onSelectFilter,
      revisions,
      reference,
      modified,
      groupedData,
      revisionData,
      modifiedRevisionCreatedBy,
      modifiedRevisionCreatedAt,
      modifiedRevisionIndex,
      originalRevisionCreatedBy,
      originalRevisionCreatedAt,
      originalRevisionIndex,
    } = this.props

    return (
        <Tabs
          index={this.state.tabIndex}
          onChange={this.onTabChange}
        >
          <Tab label={T.translate(`project.spec.tabs.${TABS.SPECIFICATION}`)}>
            <SpecificationData
              isModified={false}
              data={groupedData}
              filter={curFilter}
              tab={TABS.SPECIFICATION}
            />
          </Tab>
          <Tab label={T.translate(`project.spec.tabs.${TABS.MODIFICATION}`)}>
            <SpecificationData
              isModified={true}
              data={groupedData}
              filter={curFilter}
              tab={TABS.MODIFICATION}
            >
              <FilterDropDown
                curFilter={curFilter}
                onSelectFilter={onSelectFilter}
              />
            </SpecificationData>
          </Tab>
          <Tab label={T.translate(`project.spec.tabs.${TABS.HISTORY}`)}>
            <SpecificationData
              isModified={true}
              data={revisionData}
              filter={FILTER_MODIFIED}
              tab={TABS.HISTORY}
              modifiedRevisionLabel={"Revision " + modifiedRevisionIndex}
              originalRevisionLabel={"Revision " + originalRevisionIndex}
            >
              <RevisionDropdownContainer>
                <RevisionDropdown
                  label={T.translate('project.spec.header.modify')}
                  value={modified}
                  onChange={this.onModifiedChange}
                  createdAt={modifiedRevisionCreatedAt}
                  createdBy={modifiedRevisionCreatedBy}
                  source={revisions}
                />
                <RevisionDropdown
                  label={T.translate('project.spec.header.original')}
                  value={reference}
                  onChange={this.onReferenceChange}
                  createdAt={originalRevisionCreatedAt}
                  createdBy={originalRevisionCreatedBy}
                  source={revisions}
                />
              </RevisionDropdownContainer>
            </SpecificationData>
          </Tab>
        </Tabs>
    )
  }
}

const withSagas = injectSagas({ [MODULE_NAME]: loadSagas })
export default compose(
  withRouter,
  withSagas,
  connect(mapStateToProps, mapDispatchToProps)
)(Specifications)